import { dispatch } from '@store/index';
import { resetStep } from '@store/slices/login.slice';
import { Avatar, Dropdown } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';

const UserDropdown = () => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    dispatch(resetStep());
    navigate('/login/phone');
  };

  return (
    <Dropdown
      label="UserDropdown"
      renderTrigger={() => <Avatar rounded className="absolute right-0 mr-3" />}
      className="!left-[unset] !top-[45px] right-0 mr-3 mt-10"
    >
      <Dropdown.Item onClick={handleSignOut}>Sign out</Dropdown.Item>
    </Dropdown>
  );
};

export default UserDropdown;
